import { LucideProps } from "lucide-react";
import * as React from "react";

const StackOverflow = React.forwardRef<SVGSVGElement, LucideProps>(
    (
        {
            className,
            color = "currentColor",
            size = 24,
            strokeWidth = 2,
            ...rest
        },
        ref,
    ) => (
        <svg
            ref={ref}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 37"
            fill={color} // Uses Tailwind text-* color
            strokeWidth={strokeWidth}
            width={size}
            height={size}
            className={className} // ✅ Apply Tailwind classes here
            {...rest}
        >
            <path d="M26 33v-9h4v13H0V24h4v9h22Z" />
            <path d="m21.5 0-2.7 2 9.9 13.3 2.7-2L21.5 0ZM26 18.4 13.3 7.8l2.1-2.5 12.7 10.6-2.1 2.5ZM9.1 15.2l15 7 1.4-3-15-7-1.4 3Zm14 10.79.68-2.95-16.1-3.35L7 23l16.1 2.99ZM23 30H7v-3h16v3Z" />
        </svg>
    ),
);

StackOverflow.displayName = "StackOverflow";

export default StackOverflow;
